import { render, staticRenderFns } from "./choosePersonOne.vue?vue&type=template&id=a5b1207c&scoped=true"
import script from "./choosePersonOne.vue?vue&type=script&lang=js"
export * from "./choosePersonOne.vue?vue&type=script&lang=js"
import style0 from "./choosePersonOne.vue?vue&type=style&index=0&id=a5b1207c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b1207c",
  null
  
)

export default component.exports